module.exports = __webpack_public_path__ + "img/avatar0.ec5f2db1.png";